"use client";
import { useContext } from "react";
import { CartContext } from "@/context/CartContext";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { useShippingStore } from "@/store/Shipping";
import { MoveRight } from "lucide-react";

const Navigations = () => {
  const { addOrderProduct } = useContext(CartContext);
  const router = useRouter();
  const { setOrderFrom } = useShippingStore();

  const buyNowHandle = () => {
    addOrderProduct(cart);
    setOrderFrom("cart");
    window.location.href = "/checkout";
    // router.push("/checkout");
  };

  const { cart } = useContext(CartContext);

  return (
    <div className="flex items-center gap-4">
      {cart?.length > 0 && (
        <div className="flex items-center gap-4 justify-end mt-4">
          <Link href="/">
            <Button variant="outline">Continue Shopping</Button>
          </Link>
          <Button
            onClick={() => buyNowHandle()}
            className="w-full flex items-center gap-2 text-sm"
          >
            Checkout <MoveRight size={16} className="text-white" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default Navigations;
